  (function () {
      function initKaCouponCountdowns() {
        var boxes = document.querySelectorAll('[data-ka-coupon-countdown]');

        boxes.forEach(function (box) {
          if (box.dataset.kaCouponInitialised === 'true') return;
          box.dataset.kaCouponInitialised = 'true';

          var output = box.querySelector('[data-ka-coupon-countdown-output]');
          var endRaw = box.getAttribute('data-ka-coupon-end');

          if (!output || !endRaw) return;

          var endTime = new Date(endRaw);

          if (isNaN(endTime.getTime())) {
            output.textContent = 'limited time';
            return;
          }

          function updateCountdown() {
            var now = new Date();
            var diff = endTime - now;

            if (diff <= 0) {
              output.textContent = 'offer ended';
              box.style.display = 'none';
              return;
            }

            var days = Math.floor(diff / (1000 * 60 * 60 * 24));
            var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
            var minutes = Math.floor((diff / (1000 * 60)) % 60);
            var seconds = Math.floor((diff / 1000) % 60);

            output.textContent = days + 'd ' + hours + 'h ' + minutes + 'm ' + seconds + 's';
          }

          updateCountdown();
          setInterval(updateCountdown, 1000);
        });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initKaCouponCountdowns);
      } else {
        initKaCouponCountdowns();
      }

      document.addEventListener('shopify:section:load', initKaCouponCountdowns);
    })();